document.querySelectorAll('[data-order-lookup]').forEach(function(form){
 const root=form.closest('[data-tracking-page]');
 const results=root.querySelector('[data-tracking-results]');
 const error=root.querySelector('[data-tracking-error]');
 const button=form.querySelector('button[type=submit]');
 const originalButton=button.textContent;
 function node(tag,text,className){const el=document.createElement(tag);if(text)el.textContent=text;if(className)el.className=className;return el;}
 function render(data){
  results.replaceChildren();
  results.append(node('h2',data.order),node('p',data.status));
  data.items.forEach(function(item){
   const card=node('article',null,'wr-progress-embedded');
   card.append(node('h3',item.title),node('p',item.status));
   if(Number.isInteger(item.stage)&&item.stage>=1&&item.stage<=6){
    const bar=node('div',null,'wr-preorder-bar');
    bar.setAttribute('role','progressbar');bar.setAttribute('aria-label','Preorder progress');bar.setAttribute('aria-valuemin','1');bar.setAttribute('aria-valuemax','6');bar.setAttribute('aria-valuenow',String(item.stage));bar.setAttribute('aria-valuetext',data.stages[item.stage-1]);
    const fill=node('span');fill.style.width=((item.stage-1)*20)+'%';bar.append(fill);card.append(bar);
    const labels=node('ol',null,'wr-progress-labels');
    data.stages.forEach(function(label,index){const li=node('li',label);if(index+1===item.stage)li.setAttribute('aria-current','step');else if(index+1<item.stage)li.className='is-complete';labels.append(li);});
    card.append(labels);
   }
   if(item.note)card.append(node('p',item.note));
   results.append(card);
  });
  results.hidden=false;
 }
 form.addEventListener('submit',async function(event){
  event.preventDefault();if(!form.reportValidity()||button.disabled)return;
  error.hidden=true;results.hidden=true;results.replaceChildren();results.setAttribute('aria-busy','true');button.disabled=true;button.textContent='CHECKING…';
  const controller=new AbortController();const timeout=setTimeout(()=>controller.abort(),35000);
  try{
   const response=await fetch(form.action,{method:'POST',headers:{'Content-Type':'application/json'},credentials:'omit',cache:'no-store',referrerPolicy:'no-referrer',signal:controller.signal,body:JSON.stringify({order:form.elements.order.value.trim(),email:form.elements.email.value.trim()})});
   const data=await response.json();
   if(!response.ok)throw new Error(data.error||'Unable to check this order. Please try again.');
   render(data);
  }catch(problem){error.textContent=problem.name==='AbortError'?'The lookup timed out. Please try again.':problem.message==='Failed to fetch'?'Unable to connect. Please try again shortly.':problem.message;error.hidden=false;}
  finally{clearTimeout(timeout);button.disabled=false;button.textContent=originalButton;results.setAttribute('aria-busy','false');}
 });
});
